var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var StyledNavLink = styled(NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-weight: ", ";\n  padding: 0.7em 2em;\n  width: 100%;\n  overflow-y: hidden;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    color: ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n  }\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n  }\n"], ["\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-weight: ", ";\n  padding: 0.7em 2em;\n  width: 100%;\n  overflow-y: hidden;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    color: ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n  }\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n  }\n"])), function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.fontWeightNormal;
}, function (p) {
  return p.theme.textTertiary;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.themeName === 'dark' ? p.theme.white : p.theme.themeName === 'greenlight' ? p.theme.white : p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.primary;
}, function (p) {
  return p.theme.themeName === 'dark' ? p.theme.white : p.theme.themeName === 'greenlight' ? p.theme.white : p.theme.textPrimary;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.boxShadow;
});
var Flex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  padding-left: ", ";\n"], ["\n  display: flex;\n  padding-left: ", ";\n"])), function (p) {
  return p.subItem ? '2em' : '0';
});

var iconColor = function iconColor(p) {
  if (p.active) {
    if (p.theme.themeName === 'dark' || p.theme.themeName === 'greenlight') {
      return p.theme.white;
    } else if (p.theme.themeName === 'newlight') {
      return p.theme.primaryB;
    } else {
      return p.theme.primary;
    }
  } else {
    return p.theme.textTertiary;
  }
};

var Icon = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin-right: 0.5em;\n"], ["\n  color: ", ";\n  margin-right: 0.5em;\n"])), function (p) {
  return iconColor(p);
});

var NavItem = function NavItem(_a) {
  var children = _a.children,
      icon = _a.icon,
      location = _a.location,
      _b = _a.path,
      path = _b === void 0 ? '' : _b,
      _c = _a.subItem,
      subItem = _c === void 0 ? false : _c,
      _d = _a.alwaysShadow,
      alwaysShadow = _d === void 0 ? false : _d,
      onClick = _a.onClick,
      props = __rest(_a, ["children", "icon", "location", "path", "subItem", "alwaysShadow", "onClick"]);

  var active = location.pathname.includes(path);
  return React.createElement("li", {
    className: "nav-item",
    onClick: onClick
  }, React.createElement("div", {
    className: "" + (active ? 'active' : '')
  }, React.createElement(StyledNavLink, Object.assign({
    className: alwaysShadow ? 'alwaysShadow' : '',
    activeClassName: "active",
    to: path || ''
  }, props), React.createElement(Flex, {
    subItem: subItem
  }, icon && React.createElement(Icon, {
    className: "nav-icon",
    active: active
  }, React.createElement(FontAwesomeIcon, {
    icon: icon,
    fixedWidth: true
  })), children))));
};

export default withRouter(NavItem);
var templateObject_1, templateObject_2, templateObject_3;